<div class="dex-tranche-acts_col -purchase">
    <button class="dex-tranche-acts_btn" (click)="onTradeClick(Side.BUY, $event)">
        Purchase
    </button>
    @if (tranche().$trancheRules()) {
        <div class="dex-tranche-acts_rule-field">
            <span class="dex-tranche-acts_rule-field-label">Min ⓘ </span><span [displayDecimal]="tranche().$trancheRules().raw.depositRules.minValue | bigintDeliverableDisplayDecimal:tranche().$trancheRules().valueDeliverable"></span>
        </div>
    }
</div>

<!-- TODO: Initially staking will not be shown until staking is available -->
<div class="dex-tranche-acts_col -staking-placeholder"></div>
<!--<div class="dex-tranche-acts_col -staking-btn">
    <button class="dex-tranche-acts_btn">
        Staking
    </button>
    <div class="dex-tranche-acts_rule-field">
        <span class="dex-tranche-acts_rule-field-label">Min Period ⓘ </span><span [displayDecimal]="trancheMock.rules.minStakingPeriod" [decimalCount]="0" currency="days"></span>
    </div>
</div>
<div class="dex-tranche-acts_col -staking-rate">
    <div class="dex-tranche-acts_field">
        <div class="dex-tranche-acts_field-label">
            Staking Reward Rate
        </div>
        <div class="dex-tranche-acts_field-value">
            <span [displayDecimal]="trancheMock.status.stakingRewardRate | bigintDisplayDecimal:10:('CPLX/' + tranche.unitDeliverable.symbol + '/day')"></span>
        </div>
    </div>
    <div class="dex-tranche-acts_field">
        <div class="dex-tranche-acts_field-label">
            Total Units Staked
        </div>
        <div class="dex-tranche-acts_field-value">
            <span [displayDecimal]="trancheMock.status.totalUnitsStaked | bigintDisplayDecimal:2:tranche.unitDeliverable.symbol"></span>
        </div>
    </div>
</div>
<div class="dex-tranche-acts_col -staking-chart">
    <div class="dex-tranche-acts_change-percent">
        <span [displayDecimal]="trancheMock.status.stakingChangePercent" [decimalCount]="2" currency="%"></span>
        <span class="dex-tranche-acts_change-percent-i">ⓘ</span>
    </div>
    <sparkline
        [width]="149"
        [height]="40"
        [strokeWidth]="1"
        [data]="stakingChartData"
        [gradientOpacity]="0.5">
    </sparkline>
</div>
<div class="dex-tranche-acts_col -staking-user-stats">
    <div class="dex-tranche-acts_field">
        <div class="dex-tranche-acts_field-label">
            Your Stake
        </div>
        <div class="dex-tranche-acts_field-value">
            <span [displayDecimal]="trancheMock.userStatus.userStake | bigintDisplayDecimal:2:tranche.unitDeliverable.symbol"></span>
        </div>
    </div>
    <div class="dex-tranche-acts_field">
        <div class="dex-tranche-acts_field-label">
            CPLX Earned
        </div>
        <div class="dex-tranche-acts_field-value">
            <span [displayDecimal]="trancheMock.userStatus.cplxEarned | bigintDisplayDecimal:2:'CPLX'"></span>
        </div>
    </div>
</div>-->

<div class="dex-tranche-acts_col -redeem">
    <button class="dex-tranche-acts_btn" (click)="onTradeClick(Side.SELL, $event)">
        Redeem
    </button>
    @if (tranche().$trancheRules()) {
        <div class="dex-tranche-acts_rule-field">
            <span class="dex-tranche-acts_rule-field-label">Max ⓘ </span><span [displayDecimal]="tranche().$trancheRules().raw.withdrawalRules.maxPerBatch | bigintDeliverableDisplayDecimal:tranche().$trancheRules().valueDeliverable"></span>
        </div>
    }
</div>
